import React from 'react';
import { colors } from '../theme/designTokens';

const TIKTOK_URL = 'https://www.tiktok.com/@norbiphone';

const TikTokIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const VIDEOS = [
  {
    emoji: '⚡',
    title: 'iPhone kijelzőcsere menet közben',
    tag: 'Szerviz',
    tagColor: colors.brand,
    duration: '45 mp',
    gradient: 'from-gray-900 via-gray-800 to-gray-900',
    accent: colors.brand,
  },
  {
    emoji: '✨',
    title: 'Hidrogél fólia felhelyezés – 5 perc alatt',
    tag: 'Fólia',
    tagColor: '#1d4ed8',
    duration: '60 mp',
    gradient: 'from-slate-900 via-blue-950 to-slate-900',
    accent: '#1d4ed8',
  },
  {
    emoji: '🔄',
    title: 'Törött → javított – valódi átalakulás',
    tag: 'Before/After',
    tagColor: '#b45309',
    duration: '30 mp',
    gradient: 'from-gray-900 via-amber-950 to-gray-900',
    accent: '#b45309',
  },
  {
    emoji: '💰',
    title: 'Melyik használt iPhone éri meg valóban?',
    tag: 'Tippek',
    tagColor: '#7e22ce',
    duration: '90 mp',
    gradient: 'from-slate-900 via-purple-950 to-slate-900',
    accent: '#7e22ce',
  },
  {
    emoji: '🔋',
    title: '3 jel, hogy akkumulátort kell cserélni',
    tag: 'Tanács',
    tagColor: '#b91c1c',
    duration: '45 mp',
    gradient: 'from-gray-900 via-red-950 to-gray-900',
    accent: '#b91c1c',
  },
];

export default function TikTokSection() {
  return (
    <section className="py-16 bg-ink overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <TikTokIcon size={22} />
              <span className="text-white font-bold text-lg">@norbiphone</span>
              <span className="px-2 py-0.5 bg-white/10 rounded-full text-xs text-white/70">TikTok</span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-white">
              Nézd meg, hogyan dolgozunk
            </h2>
            <p className="text-white/50 text-sm mt-1">Valódi javítások, tippek, before/after – rövid videókban.</p>
          </div>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-5 py-2.5 bg-white text-ink font-bold rounded-full hover:bg-gray-100 transition-colors text-sm flex-shrink-0"
          >
            <TikTokIcon size={16} />
            Követés
          </a>
        </div>

        {/* Video cards – horizontal scroll on mobile */}
        <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory no-scrollbar">
          {VIDEOS.map((v, i) => (
            <a
              key={i}
              href={TIKTOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`flex-shrink-0 w-44 sm:w-48 rounded-2xl overflow-hidden snap-start bg-gradient-to-b ${v.gradient} flex flex-col justify-between p-4 group hover:scale-[1.02] transition-transform`}
              style={{ aspectRatio: '9/16' }}
              aria-label={v.title}
            >
              {/* Top: tag */}
              <div>
                <span
                  className="inline-block px-2 py-0.5 rounded-full text-xs font-bold text-white"
                  style={{ background: v.accent }}
                >
                  {v.tag}
                </span>
              </div>

              {/* Middle: emoji */}
              <div className="flex-1 flex items-center justify-center">
                <span className="text-6xl">{v.emoji}</span>
              </div>

              {/* Bottom: title + TikTok play */}
              <div>
                <p className="text-white text-xs font-semibold leading-snug mb-3 line-clamp-3">{v.title}</p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-1.5 text-white/70">
                    <div className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
                      <svg width="10" height="12" viewBox="0 0 10 12" fill="white" aria-hidden="true" focusable="false">
                        <path d="M0 0L10 6L0 12V0Z"/>
                      </svg>
                    </div>
                    <span className="text-xs">{v.duration}</span>
                  </div>
                  <TikTokIcon size={16} />
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-8">
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm font-medium transition-colors"
          >
            <TikTokIcon size={16} />
            Összes videó megtekintése a TikTokon →
          </a>
        </div>
      </div>
    </section>
  );
}
